// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"15060b6c","845":"dd00d685"}[chunkId] + ".chunk.js";
};